module.exports = __webpack_public_path__ + "static/media/video-8.85476d13.jpg";